import { render, staticRenderFns } from "./WordListMobile.vue?vue&type=template&id=2a6bbb38&scoped=true&"
import script from "./WordListMobile.vue?vue&type=script&lang=ts&"
export * from "./WordListMobile.vue?vue&type=script&lang=ts&"
import style0 from "./WordListMobile.vue?vue&type=style&index=0&id=2a6bbb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bbb38",
  null
  
)

export default component.exports